import fetch from "./fetch";
/**
 * 扫码记录
 */
const scanCodeRecord = {
  //记录分页
  getScanCodeRecord(data) {
    return fetch({
      isLoading: true,
      url: "/patient-scan-code-record/page",
      method: "POST",
      data,
    });
  },
  //记录导出
  exportScanCodeRecord(data) {
    return fetch({
      isLoading: true,
      url: "/patient-scan-code-record/exportScanCodeRecord",
      method: "POST",
      data,
    });
  },
};

export default scanCodeRecord;
